export default "__VITE_ASSET__BaiUiSfN__"